<template>
  <div>
    <h6>Online Date Upload</h6>
    <b-form-file accept=".xls, .xlsx" v-model="file" placeholder="Choose online date excel file (.xlsx) ..."></b-form-file>
    <!-- <div class="text-muted ">Not sure what to upload? Please, check forecasts file sample: <b-button @click="sample" variant="link" style="background: none">here</b-button></div> -->
    <div v-if="file">
      <b-row class="mt-1">
        <b-col sm="3">
          <label for="online_sheet_name_inp">Online date sheet name:</label>
        </b-col>
        <b-col sm="9">
          <b-form-select id="online_sheet_name_inp" size="sm" type="text" v-model="online_sheet_name" :options="sheets" placeholder="Please, select sheet with online dates data">
          </b-form-select>
        </b-col>
      </b-row>

      <div v-if="errorMs.length" class="text-danger">
        <div v-for="e in errorMs">
          {{e}}
        </div>
      </div>
      <loading-overlay :show="loading"></loading-overlay>
    </div>
    <div class="upload-check-container" v-if="file">

      <b-button :disabled="!online_sheet_name" type="submit" variant="primary" @click="upload">Upload Online dates data</b-button>
    </div>

  </div>
</template>
<script>

  import XLSX from 'xlsx'
  import LoadingOverlay from '../../LoadingOverlay'

  export default {
    components: {LoadingOverlay},
    created () {
      this.workbook = null
    },
    data () {
      return {
        file: null,
        online_sheet_name: null,
        sheets: [],
        online_date_data: {},
        loading: false,
        errorMs: []
      }
    },
    computed: {},
    watch: {
      online_sheet_name (val) {
        let XL_row_object = XLSX.utils.sheet_to_row_object_array(this.workbook.Sheets[val], { raw: false })
        this.online_date_data['online'] = this.extract_forecast_data(XL_row_object)
        this.online_date_data['online']['table_name'] = val.toLowerCase().replace(/\W+/g, '_')+"_"+(new Date().getTime())
        // console.log(this.online_date_data)
        this.validate_forecast_data(this.online_date_data['online'], val)
      },
      file (f) {
        if (!f) {
          return
        }
        let reader = new FileReader();

        this.errorMs = []
        this.sheets = []
        this.online_sheet_name = null
        this.online_date_data = {}

        let me = this;
        this.loading = true

        reader.onload = function(e) {
          let data = reader.result;
          let workbook = XLSX.read(data, {
            type: 'binary',
            cellDates: true,
            dateNF: 'mm/dd/yyyy',
          });

          me.workbook = workbook

          me.sheets.push.apply(me.sheets, workbook.SheetNames.map(s => {
            return {
              text: s,
              value: s
            }
          }))

          me.loading = false

        };

        reader.onerror = function(ex) {
          console.log(ex);
          me.loading = false
        };

        reader.readAsBinaryString(f);
      }
    },
    methods: {
      sample () {
        let url = '/static/foreacasts_sample.xlsx'
        let win = window.open(url, '_blank')
        win.focus()
      },
      validate_forecast_data (pack, sheet_name) {
        if (pack['columns'].indexOf('pad_id') < 0) {
          this.errorMs.push(`${sheet_name} doesn't contain pad_id column. \n`)
        }

        if (!sheet_name.startsWith('online_date')) {
          this.errorMs.push(`worksheet ${sheet_name} needs to start with the word online_date. \n`)
        }

        // if (!pack['columns'].filter(c => c.toLowerCase().indexOf('q') === 0 || c.toLowerCase().indexOf('2') === 0 ).length) {
        //   this.errorMs.push(`${sheet_name} doesn't seem to have any date column. Date columns should start either from Q (eg. Q1-2021) or from year (eg 2021-Q1). \n`)
        // }
      },
      extract_forecast_data (data) {
        let columns = []
        let types = []
        let datum = []

        if (data.length) {
          columns = Object.keys(data[0])
          types = columns.map(c => {
            if (c.toLowerCase().indexOf('q') > -1) {
              return 'number'
            } else {
              return 'string'
            }
          })

          data.forEach(d => {
            datum.push(columns.map((c, i) => {
              if (types[i] === 'number') {
                return parseFloat(d[c])
              } else {
                return  d[c]+''
              }
            }))
          })


        }

        return {
          columns: columns,
          data: datum,
          types: types
        }

      },
      upload () {
        let fn = () => {
          this.loading = true
          let user = this.$store.getters['user/user']
          this.$http.post('/api/admin-board/import-online-date/', {
            'data': this.online_date_data,
            'workpack_id': this.$store.getters['project/currentProject'].workpack.id
          })
            .then(res=> {
              this.$notify({
                title: 'SUCCESS',
                text: 'Online date upload successful',
                type: 'success'
              })
              this.loading = false
              this.sheets.splice(0, this.sheets.length)
              this.online_date_data = {}
              this.file = null
            }, e => {
              this.$notify({
                title: 'ERROR',
                text: 'Could not upload online dates',
                type: 'error'
              })
              this.loading = false
            })
        }

        if (this.errorMs.length) {
          if (confirm('Data is not valid. Please confirm upload.')) {
            fn()
          }
        } else {
          fn()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/admin/OnlineDateUpload.vue